{
  "_comment": "Справочник станций приезда/отъезда (словарь дропдауна «Вокзал или аэропорт»). Правки — только организаторам. Последний пункт «Самостоятельно» — не станция, а отказ от трансфера организаторов: он стоит в списке последним и выключает чекбокс «Трансфер нужен» в строке приезда или отъезда.",
  "version": 1,
  "stations": [
    {
      "id": "moskovsky",
      "name": "Московский вокзал"
    },
    {
      "id": "vitsebsky",
      "name": "Витебский вокзал"
    },
    {
      "id": "finlyandsky",
      "name": "Финляндский вокзал"
    },
    {
      "id": "ladoshsky",
      "name": "Ладожский вокзал"
    },
    {
      "id": "baltiysky",
      "name": "Балтийский вокзал"
    },
    {
      "id": "pulkovo",
      "name": "Аэропорт Пулково"
    },
    {
      "id": "self",
      "name": "Самостоятельно"
    }
  ]
}
